import { Dispatch, SetStateAction } from "react";
import { CommonDialog } from "../../../../components/common/CommonDialog";
import { DialogContent, DialogTitle, useMediaQuery, useTheme } from "@mui/material";
import { BodyAddress } from "./BodyAddress";

interface IProps {
  type: "edit" | "add";
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export function AddressDialog({ type, isOpen, setIsOpen }: IProps) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

  function handleClose() {
    setIsOpen(false);
  }

  const title = type === "edit" ? "Editar endereço" : "Adicionar endereço";

  return (
    <CommonDialog
      handleClose={handleClose}
      isOpen={isOpen}
      sheetTitle={title}
    >
      {!isMobileLayout && (
        <DialogTitle textAlign="center">{title}</DialogTitle>
      )}
      <DialogContent
        sx={{
          width: "100%",
          boxSizing: "border-box",
          px: { xs: 1.5, sm: 3 },
          pt: 0,
          pb: 1,
        }}
      >
        <BodyAddress type={type} handleClose={handleClose} />
      </DialogContent>
    </CommonDialog>
  );
}
